import $ from 'jquery';
import _ from 'underscore';
import Html from '../../../html/engine/teamChooser/teamChooser.html';
import BaseView from '../../baseView';
import { getLogger } from '../../logging/logger';
import InputManager from '../../manager/inputManager';
import Router from '../../router';
import TeamChooserGame from './gameTeamChooser';

const logger = getLogger('TeamChooser');

export default class TeamChooser extends BaseView {
	get className() {
		return 'team-chooser';
	}

	get teamClassPrefix() {
		return '';
	}

	get template() {
		return _.template(Html);
	}

	get chosenTeam() {
		return this.game.chosenTeam;
	}

	events() {
		return {
			...super.events,
			'click .team-button': 'teamChosen',
		};
	}

	initialize(options) {
		logger.log('[initialize]', options);

		InputManager.add('teamChooser', {
			selector: '.team-chooser button',
		});

		if (!this.game) {
			this.game = new TeamChooserGame(options);
		}

		this.game.once('initialized', () => {
			this.$el.removeClass('loading');

			const { skipIfComplete, pages } = this.game.pick('skipIfComplete', 'pages');

			if (this.chosenTeam && skipIfComplete && pages && pages.length) {
				// User has already selected their team. Skip to the 1st page provided instead.
				Router.navigate(pages[0].route);
			} else {
				// Business as usual
				this.game.preloadContent().then(() => {
					super.initialize(options);
					this.trigger('initialized');
				});
			}
		});
	}

	render() {
		logger.log('[render]');

		this.$el.empty().append(
			this.template(
				Object.assign(this.game.toJSON(), {
					data: this.game.rounds.toJSON(),
				}),
			),
		);

		const gameButtonSelector = `.${this.className.split(' ').shift()} .team-button`;

		this.wait(0).then(() => {
			InputManager.focus(
				this.chosenTeam ? `${gameButtonSelector}.${this.chosenTeam}` : gameButtonSelector,
			);
		});
	}

	teamChosen(e) {
		logger.log('[teamChosen]', { e });
		const bodyTag = $('body');

		// If there is a class for a previously-chosen team, remove it
		const previousTeam = this.chosenTeam;
		if (previousTeam) {
			bodyTag.removeClass(this.teamClassPrefix + previousTeam);
		}

		// Add a class to <body> for chosen team name, so that we can style arcade accordingly
		const chosenTeam = e.currentTarget.dataset.team;
		bodyTag.addClass(this.teamClassPrefix + chosenTeam);
		this.game.submitChosenTeam(chosenTeam);

		if (this.pages.length === 1) {
			Router.navigate(this.pages[0].route);
		}
	}
}
